import { useState, useEffect } from 'react';
import StateService from '../services/StateService';
import './StreakBadge.css';

function StreakBadge() {
  const [streak, setStreak] = useState(() => StateService.getStreak());

  useEffect(() => {
    return StateService.subscribe(() => {
      setStreak(StateService.getStreak());
    });
  }, []);

  if (streak === 0) return null;

  return (
    <div className="streak-badge">
      <svg className="streak-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 2C8 7 4 10 4 14a8 8 0 0016 0c0-4-4-7-8-12z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 22c-2.2 0-4-1.8-4-4 0-2 2-3.5 4-6 2 2.5 4 4 4 6 0 2.2-1.8 4-4 4z" fill="currentColor" opacity="0.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <span className="streak-count">{streak} day{streak !== 1 ? 's' : ''}</span>
    </div>
  );
}

export default StreakBadge;
